<template>
  <div v-log-a2s-contents class="page_main" data-a2s-obj-name="Terms_Page">
    <div class="header_legal">
      <div class="line_header">
        <atoms-c-image
          v-log-a2s-click
          class="img_logo"
          file-name="logo"
          :density="3"
          width="200px"
          data-a2s-obj-name="Terms_BI"
          @click="$router.push({ name: 'index' })"
        />
        <div class="txt_header">법률</div>
        <atoms-c-icon
          class="icon_menu mo_only"
          :icon-name="isOpenMobileMenu ? 'legal_close' : 'legal_burger'"
          @click="onClickMenuToggle"
        ></atoms-c-icon>
      </div>
      <div class="divider pc_only"></div>
      <div class="legal_menu" :class="{ open: isOpenMobileMenu }">
        <div class="box_item_menu">
          <nuxt-link
            v-for="menu in LEGAL_MENU"
            :key="menu.route.name"
            class="item_menu"
            :to="menu.route"
            @click="onClickMenuItem"
          >
            {{ menu.name }}
          </nuxt-link>
        </div>
      </div>
    </div>
    <div class="content_main">
      <atoms-c-image
        class="img_block left_top"
        width="160"
        height="63"
        file-name="block-cloud"
        :density="3"
      />
      <atoms-c-image
        class="img_block left_bottom"
        width="221"
        height="113"
        file-name="block-cloud-2"
        :density="3"
      />
      <atoms-c-image
        class="img_block right_bottom"
        width="160"
        height="63"
        file-name="block-cloud"
        :density="3"
      />
      <atoms-c-image
        class="img_block right_top"
        width="221"
        height="113"
        file-name="block-cloud-2"
        :density="3"
      />
      <div class="txt_title pc_only">
        {{ pageTitle }}
      </div>
      <nuxt-page />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRootStore } from '~/stores/root'
useCustomMeta('법률')
definePageMeta({
  layout: 'footer-only',
  redirect() {
    return {
      path: '/legal/term'
    }
  }
})
const LEGAL_MENU = [
  {
    route: {
      name: 'legal-type',
      params: {
        type: 'term'
      }
    },
    name: '이용약관'
  },
  {
    route: {
      name: 'legal-type',
      params: {
        type: 'operation'
      }
    },
    name: '운영정책'
  }
]
const route = useRoute()
const pageTitle = computed(() => {
  const findMenu = LEGAL_MENU.find(
    (menu) =>
      menu.route.name === route.name &&
      route.params?.type === menu.route.params.type
  )
  return findMenu?.name
})
const { isOpenMobileMenu } = storeToRefs(useRootStore())

/**
 * 모바일 메뉴 오픈 여부
 */
function onClickMenuToggle() {
  isOpenMobileMenu.value = !isOpenMobileMenu.value
}

/**
 * 메뉴명 클릭 시 이벤트
 * - 모바일일 때 햄버거 메뉴 닫기 위함
 */
function onClickMenuItem() {
  if (isOpenMobileMenu.value) {
    onClickMenuToggle()
  }
}
onBeforeUnmount(() => {
  isOpenMobileMenu.value = false
})
</script>
<style scoped lang="scss">
.header_legal {
  z-index: 11;
  position: fixed;
  width: 100%;
  padding: 0 80px;
  height: 90px;
  color: #ffffff;
  background-color: $blue1;
  display: flex;
  gap: 26px;
  align-items: center;
  .line_header {
    display: flex;
    gap: 20px;
    .txt_header {
      font-size: 26px;
      font-weight: 700;
      line-height: 1.5;
      letter-spacing: -1.04px;
    }
    .img_logo {
      cursor: pointer;
      object-fit: contain;
    }
  }
  .divider {
    margin: 0 6px;
    width: 1px;
    height: 24px;
    opacity: 0.5;
    background-color: #ffffff;
  }
  .legal_menu {
    height: 100%;
    .box_item_menu {
      gap: 24px;
      height: 100%;
      display: flex;
    }
    .item_menu {
      height: inherit;
      cursor: pointer;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.5;
      letter-spacing: -0.8px;
      opacity: 0.5;
      align-content: center;
      box-sizing: border-box;
      width: 80px;
      display: inline-block;
      text-align: center;
      &.router-link-active {
        opacity: 1;
        color: #ffe130;
        padding-top: 4px;
        border-bottom: 4px solid #ffe130;
      }
    }
  }
}
.page_main {
  background-position: center bottom -1px;
  @include imageSet('@/assets/images/bg-legal');
  background-color: $bg-l-blue1;
  overflow: hidden;
  min-width: 360px;
  .content_main {
    padding: 190px 0 100px;
    width: calc(100% - 64px);
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
    text-align: center;
    text-align: -webkit-center;
    .img_block {
      position: absolute;
      &.left_bottom {
        left: -290px;
        top: 1040px;
        transform: scaleX(-1);
      }
      &.left_top {
        left: -110px;
        top: 825px;
        width: 110px;
        object-fit: cover;
        object-position: left;
      }
      &.right_top {
        width: 200px;
        right: -200px;
        top: 440px;
        object-fit: cover;
        object-position: right;
      }
      &.right_bottom {
        top: 1281px;
        right: -260px;
      }
    }
  }
  .txt_title {
    color: $black0;
    font-size: 40px;
    font-weight: 800;
    line-height: 1.5;
    letter-spacing: -2.56px;
  }
}
@media (max-width: 999px) {
  .header_legal {
    padding: 0;
    height: unset;
    flex-direction: column;
    box-sizing: border-box;
    background-color: transparent;
    gap: 0;
    .line_header {
      background-color: $blue1;
      width: 100%;
      align-items: center;
      flex-shrink: 0;
      flex-basis: 64px;
      padding: 0 16px;
      box-sizing: border-box;
      .txt_header {
        font-size: 16px;
        line-height: 1;
        letter-spacing: -0.64px;
      }
      .img_logo {
        width: 135px;
        margin-top: -3px;
      }
      .icon_menu {
        cursor: pointer;
        margin-left: auto;
      }
    }
    .legal_menu {
      display: none;
      width: 100%;
      height: calc(100vh - 64px - var(--bannerHeight));
      flex-direction: column;
      overflow-y: auto;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.5);
      &.open {
        display: block;
      }
      .box_item_menu {
        display: block;
        padding: 20px;
        background-color: #ffffff;
        height: auto;
      }
      .item_menu {
        color: $black0;
        width: 100%;
        padding: 12px;
        font-size: 16px;
        opacity: 1;
        background-color: #ffffff;
        &.router-link-active {
          padding: 12px;
          border-bottom: none;
          color: $blue1;
        }
      }
    }
  }
  .page_main {
    @include imageSet('@/assets/images/bg-legal-mo');
    .content_main {
      width: auto;
      padding: 64px 0 80px;
      .img_block {
        display: none;
      }
    }
  }
}
</style>
